<template>
  <tr>
    <td>
      <div class="items-wrapper d-flex align-items-center">
        {{ user.first_name }} {{ user.last_name }}
      </div>
    </td>
    <td nowrap>{{ user.email }}</td>
    <td>{{ replacePhone(user.phone) }}</td>
    <td class="text-center">{{ getUserType(user.type) }}</td>
    <td class="text-center">{{ user.format_date }}</td>
    <td>{{ user.timezone_data.utc_timezone }}</td>
    <td>
      <div class="icon-wrapper justify-content-between d-flex">
        <button
          @click="setInputValues"
          data-bs-toggle="modal"
          :data-bs-target="`#editModalUserManagment-${user.id}`"
          class="btn btn-link"
          style="color: #666; font-size: 16px"
        >
          <i class="fas fa-pencil-alt"></i>
        </button>

        <button
          @click="setUserToDelete"
          style="color: #666; font-size: 16px"
          data-bs-toggle="modal"
          :data-bs-target="`#deleteModalUserManagment-${user.id}`"
          class="btn btn-link"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Edit Modal -->
      <div
        class="modal fade add-user-modal"
        :id="`editModalUserManagment-${user.id}`"
        tabindex="-1"
        aria-labelledby="editModalUserManagment"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="editModalUserManagment">Edit User</h5>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref="closeEdit"
                @click="resetEdit"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="padding: 35px 40px 0 40px">
              <div class="d-flex align-items-center">
                <div class="form-group flex-grow-1 mr-2">
                  <div class="form-group m-label-left">
                    <input id="name" type="text" class="form-control" v-model="editFirstName" />
                    <label for="name">First Name</label>
                  </div>
                  <div class="form-group m-label-left">
                    <input id="last" type="text" class="form-control" v-model="editLastName" />
                    <label for="last">Last Name</label>
                  </div>
                  <div class="form-group m-label-left">
                    <input id="email" type="text" class="form-control" v-model="editEmailAddress" />
                    <label for="email">Email</label>
                  </div>
                  <div class="row">
                    <div class="form-group m-label col-md-4 country-code-user no-hor">
                      <v-select
                        id="country-code"
                        style="font-size: 14px; height: 42px"
                        @input="addCountryCodeEdit(editCountryCode)"
                        v-model="editCountryCode"
                        :options="
                          [...getAllCountries].map(item => `${item.phone_code} ${item.name}`)
                        "
                        :clearable="false"
                      >
                        <template v-slot:option="option">
                          {{ option.label }}
                        </template>
                      </v-select>
                      <label for="country-code">Country Code</label>
                    </div>
                    <div class="form-group m-label col-md-8">
                      <input id="phone" type="text" class="form-control" v-model="editPhone" />
                      <label for="phone">Phone</label>
                    </div>
                  </div>

                  <div class="form-group m-label-left">
                    <select v-model="editRole" id="role" class="form-control">
                      <option :value="2">Manager</option>
                      <option :value="1">User</option>
                    </select>
                    <label for="role">Role</label>
                  </div>

                  <div class="form-group m-label-left">
                    <select v-model="editDateFormat" id="role" class="form-control">
                      <option value="YY-MM-DD">YY-MM-DD</option>
                      <option value="YY/MM/DD">YY/MM/DD</option>
                      <option value="DD-MM-YY">DD-MM-YY</option>
                      <option value="DD/MM/YY">DD/MM/YY</option>
                      <option value="MM-DD-YY">MM-DD-YY</option>
                      <option value="MM/DD/YY">MM/DD/YY</option>
                    </select>
                    <label for="role">Date Format</label>
                  </div>
                  <div class="form-group m-label-left country-code-user">
                    <v-select
                      ref="tzSelect"
                      placeholder="Select Timezone"
                      v-model="timeZone"
                      :options="tzOptions"
                      :clearable="false"
                      :reduce="zone => zone"
                      :filterable="false"
                      label="utc_timezone"
                      @search="onTzSearch"
                      @open="onTzOpen"
                    >
                      <template #option="{ utc_timezone }">
                        {{ utc_timezone }}
                      </template>
                      <template #selected-option="{ utc_timezone }">
                        {{ utc_timezone }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer text-center justify-content-center">
              <button @click="onEditUser" type="button" class="btn btn-primary">
                Save changes
              </button>
              <button
                @click="resetEdit"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Modal -->
      <div
        class="modal fade edit-modal"
        :id="`deleteModalUserManagment-${user.id}`"
        tabindex="-1"
        aria-labelledby="deleteModalUserManagment"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="deleteModalUserManagmentLabel">Delete User</h5>
              <button
                type="button"
                class="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref="closeDelete"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body text-center justify-content-center">
              <p>
                Please confirm that you want to delete
                <strong>{{ user.first_name }} {{ user.last_name }}</strong>
              </p>
            </div>
            <div class="modal-footer text-center justify-content-center">
              <button @click="onDeleteUser" type="button" class="btn btn-primary">Delete</button>

              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { TIME_ZONES } from '../../constants';
export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    /* Edit Variables */
    editUserID: '',
    editFirstName: '',
    editLastName: '',
    editEmailAddress: '',
    editCountryCode: '',
    editPhone: '',
    editRole: 0,
    editDateFormat: '',
    timeZone: '',
    deleteUserID: '',
    timeZonePreview: '',
    tzOptions: [],
    tzPage: 1,
    tzLastPage: 1,
    tzSearch: '',
    tzLoading: false,
    tzSearchTimeout: null,
  }),
  methods: {
    fetchTimezones(reset = false) {
      if (this.tzLoading) return;
      if (!reset && this.tzPage > this.tzLastPage) return;
      this.tzLoading = true;
      if (reset) {
        this.tzPage = 1;
        this.tzLastPage = 1;
      }
      axios(`${process.env.VUE_APP_API_URL}/common/timezone/all`, {
        method: 'post',
        data: { page: this.tzPage, count: 50, search_word: this.tzSearch },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          Accept: 'application/json',
        },
      })
        .then(res => {
          const raw = res.data.data !== undefined ? res.data.data : res.data;
          const items = Array.isArray(raw) ? raw : Object.values(raw);
          if (reset) {
            this.tzOptions = items;
          } else {
            const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
            const scrollTop = dropdown ? dropdown.scrollTop : 0;
            items.forEach(item => this.tzOptions.push(item));
            this.$nextTick(() => {
              if (dropdown) dropdown.scrollTop = scrollTop;
            });
          }
          this.tzLastPage = res.data.last_page;
          this.tzPage += 1;
        })
        .catch(() => {})
        .finally(() => {
          this.tzLoading = false;
        });
    },
    onTzSearch(search) {
      clearTimeout(this.tzSearchTimeout);
      this.tzSearchTimeout = setTimeout(() => {
        this.tzSearch = search;
        this.fetchTimezones(true);
      }, 300);
    },
    onTzOpen() {
      this.$nextTick(() => {
        const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
        if (!dropdown) return;
        dropdown.addEventListener('scroll', this.onTzScroll);
      });
    },
    onTzScroll(e) {
      const el = e.target;
      if (this.tzPage > this.tzLastPage) return;
      if (this.tzLoading) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
        this.fetchTimezones();
      }
    },
    setInputValues() {
      this.fetchTimezones(true);
      let extractedNumbers = this.user.phone.match(/^(\+\d+)\s/);
      if (extractedNumbers) {
        let countryCode = extractedNumbers[1]; // Extracted numbers before the space
        let exists = this.getAllCountries.find(country => country.phone_code === countryCode);

        if (exists) {
          this.editCountryCode = exists.name;
        } else {
          this.editCountryCode = '';
        }
      }
      this.editUserID = this.user.id;
      this.editFirstName = this.user.first_name;
      this.editLastName = this.user.last_name;
      this.editEmailAddress = this.user.email;
      this.editPhone = this.user.phone;
      this.editRole = this.user.type;
      this.editDateFormat = this.user.format_date;
      this.timeZone = this.user.timezone_data;
    },
    getCountryCode(phone) {
      return phone.substring(0, phone.indexOf(' ')) + ' ';
    },
    addCountryCode(code) {
      this.countryCode = code.replace(/[0-9+]/g, '');
      this.phone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    addCountryCodeEdit(code) {
      this.editCountryCode = code.replace(/[0-9+]/g, '');
      this.editPhone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    replacePhone(phone) {
      if (phone) {
        phone = phone.replace(/[^\d\s]/g, '');
        return `+${phone}`;
      }
      /*     return phone.replace(/\D/g, ''); */
    },
    getUserType(type) {
      if (type === 2) {
        return 'Manager';
      } else {
        return 'User';
      }
    },
    resetEdit() {
      this.editCountryCode = '';
      this.editUserID = '';
      this.editFirstName = '';
      this.editLastName = '';
      this.editEmailAddress = '';
      this.editRole = '';
      this.editDateFormat = '';
      this.editPhone = '';
    },
    onEditUser() {
      axios(`${process.env.VUE_APP_API_URL}/manager/users/update`, {
        method: 'post',
        data: {
          user_profile_id: this.editUserID,
          first_name: this.editFirstName,
          last_name: this.editLastName,
          country_code: this.editCountryCode,
          phone: this.editPhone,
          user_type: this.editRole,
          format_date: this.editDateFormat,
          timezone_id: this.timeZone.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(() => {
        this.$emit('retrieve-user-manager');
        this.$refs.closeEdit.click();

        this.$toasted.success('User successfully edited.', {
          theme: 'bubble',
          icon: 'fa-unlock-alt',
          position: 'bottom-right',
          duration: 5000,
        });
      });
    },
    setUserToDelete() {
      this.deleteUserID = this.user.id;
    },
    onDeleteUser() {
      axios(`${process.env.VUE_APP_API_URL}/manager/users/delete/${this.deleteUserID}`, {
        method: 'delete',
        data: {
          user_profile_id: this.deleteUserID,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$emit('delete-user-manager');
          this.$refs.closeDelete.click();
          this.$toasted.success('User successfully deleted.', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(err => {
          if (err.response.data) {
            this.$toasted.error(err.response.data, {
              theme: 'bubble',
              icon: 'fa-unlock-alt',
              position: 'bottom-right',
              duration: 5000,
            });
          }
        });
    },
  },
  computed: {
    ...mapGetters(['getAllCountries']),
    getTimeZones() {
      return TIME_ZONES;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

tr {
  td {
    .icon-wrapper {
      float: right;
      margin-right: 18px;
    }

    /*  a {
      color: #a7a7a7;

      i {
        font-size: 16px;
      }
    } */
  }
}
</style>
